import { render, staticRenderFns } from "./ServicePayInfo.vue?vue&type=template&id=2d47cdfb&scoped=true"
import script from "./ServicePayInfo.vue?vue&type=script&lang=js"
export * from "./ServicePayInfo.vue?vue&type=script&lang=js"
import style0 from "./ServicePayInfo.vue?vue&type=style&index=0&id=2d47cdfb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d47cdfb",
  null
  
)

export default component.exports